import { useCallback, useEffect, useState } from 'react';
import { Area } from 'react-easy-crop';

interface UseImageUploadProps {
  onCropCompleteAction: (croppedAreaPixels: Area) => void;
  initialImage?: string | null;
}

export const useImageUpload = ({ onCropCompleteAction, initialImage = null }: UseImageUploadProps) => {
  const [imageSrc, setImageSrc] = useState<string | null>(initialImage);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    setImageSrc(initialImage ?? null);
  }, [initialImage]);

  const handleFileProcess = useCallback(async (file: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      setImageSrc(dataUrl);
      resolve(dataUrl);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  }), []);

  const onCropComplete = useCallback(
    (_: Area, croppedAreaPixels: Area) => {
      onCropCompleteAction(croppedAreaPixels);
    },
    [onCropCompleteAction]
  );

  const reset = useCallback(() => {
    setImageSrc(null);
    setZoom(1);
    setCrop({ x: 0, y: 0 });
  }, []);

  return {
    imageSrc,
    crop,
    zoom,
    setCrop,
    setZoom,
    onCropComplete,
    handleFileProcess,
    reset,
  };
};

export default useImageUpload;